'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PageLink = require('containers/PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _NewsletterForm = require('components/NewsletterForm/NewsletterForm');

var _NewsletterForm2 = _interopRequireDefault(_NewsletterForm);

var _Icon = require('components/Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Logo = require('components/Logo/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _footer = require('./footer.css');

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this));

    _this.state = {
      focusInput: false,
      office: {},
      footer: {},
      finishLoading: false
    };
    return _this;
  }

  _createClass(Footer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var fetchContact = this.props.fetchContact;

      fetchContact();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.office !== newProps.office) {
        this.setState({
          office: newProps.office,
          finishLoading: true
        });
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.setState({ focusInput: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.setState({ focusInput: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var office = this.state.office;


      return _react2.default.createElement(
        'div',
        { className: _footer2.default.footer },
        _react2.default.createElement(
          'div',
          { className: _footer2.default.inner },
          _react2.default.createElement(
            'div',
            { className: _footer2.default.half },
            _react2.default.createElement(_Logo2.default, { isLoading: true }),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _PageLink2.default,
                { className: _footer2.default.spotifyLink, to: '/showreel' },
                'Watch our showreel'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _footer2.default.newsletter },
              'Stay up to date with everything from Soundscape sign up to our newsletter.',
              _react2.default.createElement(_NewsletterForm2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _footer2.default.quart },
            _react2.default.createElement(
              'div',
              { className: _footer2.default.title },
              'Address'
            ),
            _react2.default.createElement(
              'div',
              null,
              office.line1 || ''
            ),
            _react2.default.createElement(
              'div',
              null,
              office.line2 || ''
            ),
            _react2.default.createElement(
              'div',
              null,
              office.line3 || ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _footer2.default.quart },
            _react2.default.createElement(
              'div',
              { className: _footer2.default.title },
              'Contact'
            ),
            _react2.default.createElement(
              'div',
              null,
              office.telephone || ''
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: 'mailto:' + (office.email || '') },
                office.email || ''
              )
            ),
            _react2.default.createElement(
              'div',
              { className: _footer2.default.social },
              _react2.default.createElement(
                'a',
                { className: _footer2.default.socialLink, href: 'https://www.instagram.com/soundscapeagency/', target: '_blank' },
                _react2.default.createElement(_Icon2.default, { type: 'instagram', width: 20, height: 20 })
              ),
              _react2.default.createElement(
                'a',
                { className: _footer2.default.socialLink, href: 'https://www.facebook.com/soundscapemusicagency/', target: '_blank' },
                _react2.default.createElement(_Icon2.default, { type: 'facebook', width: 17, height: 19 })
              ),
              _react2.default.createElement(
                'a',
                { className: _footer2.default.socialLink, href: 'https://www.linkedin.com/company-beta/10405811/?pathWildcard=10405811', target: '_blank' },
                _react2.default.createElement(_Icon2.default, { type: 'linkedin', width: 17, height: 19 })
              )
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react.Component);

exports.default = Footer;


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.js
// module id = 323
// module chunks = 1